module.exports = __webpack_public_path__ + "img/bg3.ca888154.png";